import React from 'react';
import PropTypes from 'prop-types';
import { StatusIndicator } from '@getro/rombo';

export const statusConfig = {
  closed: { status: 'Closed' },
  active: { status: 'Open', statusColor: 'success' },
  expired: { status: 'Expired', statusColor: 'warning' },
};

const JobStatus = ({ job }) => {
  const { status } = job;

  if (statusConfig[status]) {
    return <StatusIndicator {...statusConfig[status]} />;
  }

  return <StatusIndicator status={status} />;
};

JobStatus.propTypes = {
  job: PropTypes.shape({
    status: PropTypes.string.isRequired,
    passesFilter: PropTypes.bool,
  }).isRequired,
};

export default JobStatus;
